<template>
  <div id="apptab">
    <div class="weui-tab">
      <merchant></merchant>
      <div class="weui-tab__panel">
        <router-view v-if="isRouterAlive" :key="$route.fullPath" />
      </div>
      <menuSecond ref="menu_second"></menuSecond>

      <!-- tab -->
      <div id="tab" class="weui-tabbar">
        <div
          class="weui-tabbar__item"
          cmd="action"
          v-bind:class="{ 'weui-bar__item_on blue': isReport }"
          @click="handleClick1('report')"
        >
          <div style="display: inline-block; position: relative">
            <div class="weui-tabbar__icon">
              <i class="bi bi-clipboard-data-fill"></i>
            </div>
          </div>
          <p class="weui-tabbar__label">经营报表</p>
        </div>
        <div
          class="weui-tabbar__item"
          cmd="partner"
          v-bind:class="{ 'weui-bar__item_on blue': isConfig }"
          @click="handleClick1('config')"
        >
          <div class="weui-tabbar__icon">
            <!--<i class="bi bi-gear"></i>--><i class="bi bi-people-fill"></i>
          </div>
          <p class="weui-tabbar__label">客户服务</p>
        </div>
        <div
          class="weui-tabbar__item"
          v-bind:class="{ 'weui-bar__item_on blue': isMessage }"
          @click="handleClick1('message')"
        >
          <div class="weui-tabbar__icon">
            <!--<i class="bi bi-chat-square-dots"></i>--><i
            class="bi bi-gear-fill"
          ></i>
          </div>
          <p class="weui-tabbar__label">配置管理</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {queryzmEmployeeIndentity} from "./graphql/api";
import menuSecond from "./components/menuSecond.vue";
import {getCosTempToken} from "./api";
import Axios from "axios";
import {v4 as uuidv4} from 'uuid';

import merchant from "./components/merchant.vue";

export default {
  components: {menuSecond,merchant},
  // 提供变量
  provide() {
    // 父组件中通过provide来提供变量，在子组件中通过inject来注入依赖
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
      partnerid: "",
      isConfig: false,
      isMessage: false,
      isReport: true,
      reports: [
        // 经营报表
        // {'url':'hexiaopage','caption':'核销页面'},
        {url: "report_flow_all", caption: "流水变动日报"},
        //  {'url':'report_flow','caption':'充值订单日报'},
        {url: "report_order", caption: "订单统计日报"},
        /*{url: "material_declarationList", caption: "网点申报列表"},
        {url: "material_query", caption: "网点申报查询"},*/

        //  {'url':'report_customer','caption':'客户统计日报'},
        //  {'url':'report_service','caption':'网点服务日报'},
      ],
      configs: [
        // 客户服务
        {url: "refund_apply_mgr", caption: "退款管理"},
        {url: "invoice_apply_mgr", caption: "发票管理"},
        {url: "userlist", caption: "客户列表"},
        {url: "orderlist", caption: "订单列表"},
        // {'url':'orderlist_user','caption':'客户订单'},
        {url: "token_check", caption: "凭证核验"},
        {url: "comments_reply", caption: "评论回复"},
        {url: "coupon_activity_list", caption: "优惠券活动"},
        {url: "coupon_list", caption: "优惠券列表"}
        // {url: "material_declarationList", caption: "网点申报"},
        //{'url':'config_pay','caption':'结算方式'},
        //{'url':'config_agent','caption':'营销策略'}
      ],
      configs_mgr: [
        // 客户服务
        {url: "ld_deposit_apply_mgr", caption: "提现管理"},
        {url: "refund_apply_mgr", caption: "退款管理"},
        {url: "invoice_apply_mgr", caption: "发票管理"},
        {url: "userlist", caption: "客户列表"},
        {url: "orderlist", caption: "订单列表"},
        // {'url':'orderlist_user','caption':'客户订单'},
        {url: "token_check", caption: "凭证核验"},
        {url: "monitor_screen", caption: "客服在线"},
        {url: "comments_reply", caption: "评论回复"},
        {url: "coupon_activity_list", caption: "优惠券活动"},
        {url: "coupon_list", caption: "优惠券列表"}
        //{'url':'config_pay','caption':'结算方式'},
        //{'url':'config_agent','caption':'营销策略'}
      ],
      messages: [
        // 配置管理
        {url: "config_product", caption: "产品管理"},
        {url: "posList", caption: "网点列表"},
        {url: "asset_mgr", caption: "资产管理"},
        {url: "operation_mgr", caption: "营销策略"},
        {url: "system_message", caption: "系统消息"},
        {url: "employee_approval", caption: "雇员审批"},
        {url: "cashier_mgr", caption: "收银管理"},
        {url: "gen_qr_code", caption: "门店二维码生成"}
      ],
      messages_mgr: [
        // 配置管理
        {url: "plate_msg", caption: "车牌上报消息"},
        {url: "posList", caption: "网点列表"},
        {url: "config_product", caption: "产品管理"},
        // {'url':'apply_maintanance','caption':'故障报修'},
        // {'url':'pos_mgr','caption':'网点管理'},
        {url: "asset_mgr", caption: "资产管理"},
        {url: "operation_mgr", caption: "营销策略"},
        {url: "system_message", caption: "系统消息"},
        {url: "employee_approval", caption: "雇员合作审批"},
        {url: "partner_mgr", caption: "商户管理"},
        {url: "cashier_mgr", caption: "收银管理"},
        // {url: "approve_merchant", caption: "微信商户审批"},
        {url: "pos_approval", caption: "门店合作审批"},
        {url: "gen_qr_code", caption: "门店二维码生成"}
      ],
    };
  },
  created: function () {
    /*if (window.location.href.indexOf("report") > 0) {
      this.isReport = true;
      this.isMessage = false;
      this.isConfig = false;
    } else if (window.location.href.indexOf("message") > 0) {
      this.isReport = false;
      this.isMessage = true;
      this.isConfig = false;
    } else if (window.location.href.indexOf("config") > 0) {
      this.isReport = false;
      this.isMessage = false;
      this.isConfig = true;
    } else if (window.location.href.indexOf("login") > 0) {
      console.log(window.location.href);
    } else {
      this.$router.push("/");
    }*/
  },
  mounted() {
    this.getIdentity();

    // 解决页面刷新后jsAPi权限丢失的问题 Joen 2023/5/22
    window.addEventListener("load", () => {
      this.jsapiInit();
    });
  },
  methods: {
    // 查询用户当前是否是众敏雇员
    getIdentity() {
      queryzmEmployeeIndentity().then((res) => {
        console.log("用户权限", res);
        try {
          if (res.data.zhmEmployeeAuth) {
            sessionStorage.setItem("zmEmployee", "true");
          } else {
            sessionStorage.setItem("zmEmployee", "false");
          }
        } catch (e) {
          alert(`查询用户权限异常${e}`);
        }
      });
    },

    // 获取jsapi权限
    jsapiInit() {
      let jsApiList = [
        'chooseWXPay',
        'getLocation',
        'openLocation',
        'scanQRCode',
        'updateTimelineShareData',
        'updateAppMessageShareData',
        'startRecord',
        'stopRecord',
        'onVoiceRecordEnd',
        'uploadVoice',
        'downloadVoice',
        "translateVoice",
        'playVoice',
        'scanQRCode']
      // 设定默认经纬度
      // 发起请求获取Jsapi配置凭证
      let url = window.location.href.split('#')[0]
      let resStructure
      Axios.post('/customer/zmxcl/entry', {
        msgType: 'getJsapiConfig',  //
        ver: '1', //
        msgID: uuidv4(), //
        timestamp: Date.now(), //
        url: url //
        // 拦截响应
      }).then(response => {
        resStructure = response
        let data = response.data.wxJsapiConfigRequestInfo

        // 通过config接口注入权限验证配置
        wx.config({
          debug: false,  //开启调试模式，调用所有api的返回值会在客户端alert出来，
          appId: data.appId, //公众号唯一标识
          timestamp: data.timestamp, //生成签名的时间戳
          nonceStr: data.nonceStr, //生成签名的随机串
          signature: data.signature, //签名
          jsApiList: jsApiList //需要使用的JS接口列表
        })

      }).catch(error => {
        console.log('jsapi获取异常',error);
      })
    },

    // 控制页面刷新
    reload() {
      this.isRouterAlive = false; //先关闭
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
    checkRight() {
      this.partnerid = sessionStorage.getItem("partnerid");

      console.log(this.partnerid);

      if (this.partnerid == null || this.partnerid.length < 4) return false;

      if (this.partnerid == "M2022060601") {
        this.messages = this.messages_mgr;
        this.configs = this.configs_mgr;
      }

      return true;
    },
    handleClick1(cmd) {
      if (!this.checkRight()) {
        alert("请确认已经开通了商户管理员权限 ");
        return;
      }
      console.log(cmd);
      switch (cmd) {
        case "report":
          this.isReport = true;
          this.isMessage = false;
          this.isConfig = false;
          this.$refs.menu_second.initMenu(this.reports);
          break;
        case "config":
          this.isReport = false;
          this.isMessage = false;
          this.isConfig = true;
          this.$refs.menu_second.initMenu(this.configs);
          break;
        case "message":
          this.isReport = false;
          this.isMessage = true;
          this.isConfig = false;
          this.$refs.menu_second.initMenu(this.messages);
          break;
      }

      // $(this).addClass('weui-bar__item_on').siblings('.weui-bar__item_on').removeClass('weui-bar__item_on')
    },
  },
};
</script>

<style>
#apptab {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  border: 1px;
  /* 如下确保tab靠底边：html、body应该设定样式为height:100%*/
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  //color: var(--weui-FG-0);
}

.left {
  align-content: left;
  align-self: left;
  text-align: left;
}

.blue {
  color: blue;
  font: bold;
}
</style>
<style src="./css/common.css">

</style>



// WEBPACK FOOTER //
// src/App.vue